<template>
  <v-container style="max-width: 900px;">
    <v-card>
      <v-card-title class="headline">
        Allekirjoitukset
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            class="d-flex"
            cols="12"
            sm="4"
          >
            <v-select
              v-model="year"
              :items="years"
              hide-details
              outlined
              label="Vuosi"
              @change="getReports()"
            />
          </v-col>
          <v-col
            class="d-flex"
            cols="12"
            sm="4"
          >
            <v-select
              v-model="month"
              :items="months"
              item-text="text"
              hide-details
              outlined
              item-value="value"
              label="Kuukausi"
              @change="getReports()"
            />
          </v-col>
          <v-col
            class="d-flex"
            cols="12"
            sm="4"
          >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              outlined
              label="Search"
              single-line
              hide-details
            />
          </v-col>
        </v-row>
        <h2 class="mb-3 mt-4">
          DIAS-kaupat
        </h2>
        <v-data-table
          :headers="diasheaders"
          :items="signaturesObject.diastrades"
          :footer-props="{
            'items-per-page-options': [25, 50, 100, 150, 500]
          }"
          :items-per-page="100"
          :search="search"
          class="elevation-1"
        />
        <h2 class="mb-3 mt-4">
          Toimeksiantosopimukset
        </h2>
        <v-data-table
          :headers="headers"
          :items="signaturesObject.agreementsignatures"
          :footer-props="{
            'items-per-page-options': [25, 50, 100, 150, 500]
          }"
          :items-per-page="100"
          :search="search"
          class="elevation-1"
        />
        <h2 class="mb-3 mt-4">
          Ostotoimeksiantosopimukset
        </h2>
        <v-data-table
          :headers="headers"
          :items="signaturesObject.buyordersignatures"
          :footer-props="{
            'items-per-page-options': [25, 50, 100, 150, 500]
          }"
          :items-per-page="100"
          :search="search"
          class="elevation-1"
        />
        <h2 class="mt-5 mb-3">
          Sähköiset tarjoukset
        </h2>
        <v-data-table
          :headers="headers"
          :items="signaturesObject.offersignatures"
          :footer-props="{
            'items-per-page-options': [25, 50, 100, 150, 500]
          }"
          :items-per-page="100"
          :search="search"
          class="elevation-1"
        />
        <h2 class="mt-5 mb-3">
          Muut allekirjoitusmenettelyt
        </h2>
        <v-data-table
          :headers="headers"
          :items="signaturesObject.filesignatures"
          :footer-props="{
            'items-per-page-options': [25, 50, 100, 150, 500]
          }"
          :items-per-page="100"
          :search="search"
          class="elevation-1"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { apiGet } from '../api';

const year = new Date().getFullYear();
const month = new Date().getMonth() + 1;

export default {
  data: () => ({
    year,
    month,
    headers: [
      {
        text: 'Yritys',
        align: 'start',
        value: 'nimi',
      },
      { text: 'Määrä', value: 'signatureCount' },
    ],
    diasheaders: [
      {
        text: 'Yritys',
        align: 'start',
        value: 'nimi',
      },
      { text: 'Kohdenimi', value: 'property_name' },
      { text: 'Yhteensä', value: 'total' },
    ],
    signatures: [],
    search: '',
    signaturesObject: {},
    months: [
      { value: 1, text: 'Tammikuu' },
      { value: 2, text: 'Helmikuu' },
      { value: 3, text: 'Maaliskuu' },
      { value: 4, text: 'Huhtikuu' },
      { value: 5, text: 'Toukokuu' },
      { value: 6, text: 'Kesäkuu' },
      { value: 7, text: 'Heinäkuu' },
      { value: 8, text: 'Elokuu' },
      { value: 9, text: 'Syyskuu' },
      { value: 10, text: 'Lokakuu' },
      { value: 11, text: 'Marraskuu' },
      { value: 12, text: 'Joulukuu' },
    ],
  }),
  computed: {
    years() {
      const d = new Date();
      const n = d.getFullYear();
      const years = [];
      for (let index = 0; index < 10; index += 1) {
        years.push(n - index);
      }
      return years;
    },
  },
  mounted() {
    this.getReports();
  },
  methods: {
    async getReports() {
      const response = await apiGet(`reporting/signatures/${this.year}/${this.month}`);
      this.signaturesObject = response.result;
      this.signaturesObject.diastrades = this.signaturesObject.diastrades.map(trade => ({
        nimi: trade.nimi,
        property_name: this.signaturesObject.diastrades.filter(t => t.nimi === trade.nimi).map(trd => trd.property_name).join(', '),
        total: this.signaturesObject.diastrades.filter(t => t.nimi === trade.nimi).length,
      })).filter((v, i, a) => a.findIndex(t => (t.nimi === v.nimi)) === i);
    },
  },
};
</script>
